import { FC } from 'react';
import { Text, TextProps } from '@chakra-ui/react';

import { AddressSchema } from '../../../components/AddressForm/addressSchema';

type Props = TextProps & {
  address: AddressSchema;
};

/**
 * A component displaying an address
 */
const FormattedAddress: FC<Props> = ({ address, ...props }) => {
  const { city, street, streetAddition, zip } = address;

  return (
    <Text {...props}>
      {`${street}\n`}

      {streetAddition ? `${streetAddition}\n` : null}

      {`${zip} ${city}`}
    </Text>
  );
};

export default FormattedAddress;
